﻿var closeButton = document.getElementById('nav-active-header-close-button');
var contactUs = document.querySelector('.zen-nav-menu-footer-mobile__contact a');
var vehicleMakeLastChild = document.querySelector('.sub-nav-menu-all .nav-submenu__item:last-of-type a');
var vehicleTypeLastChild = document.querySelector('.sub-nav-menu-types .nav-submenu__item:last-child a');
var viewBudgetResultsButton = document.getElementById('view-budget-results-cta');
var viewCarResultsButton = document.getElementById('view-cars-results-cta');

// Select all last-of-type items initially
var allLastItemLinks = document.querySelectorAll('.sub-nav-menu-container .nav-submenu__item:last-of-type a');

// Filter out those within .sub-nav-menu-popular
var lastItemLinks = Array.from(allLastItemLinks).filter(link => {
    return !link.closest('.sub-nav-menu-popular');
});

var backButtons = document.querySelectorAll('.nav-submenu__back-bar-link');

export const zenNavLoop = () => {
    const isMobile = () => window.innerWidth <= 767;

    function handleShiftTab(event) {
        var navElement = document.querySelector('.nav-submenu__list--open');
        if (navElement == null) {
            if (event.key == 'Tab' && event.shiftKey) {
                event.preventDefault();
                contactUs.focus();
            }
        } else {
            const lastChildManufacturer = document.querySelector('.nav-submenu__list--open .sub-nav-menu-all .nav-submenu__item:last-of-type a');
            const lastChildType = document.querySelector('.nav-submenu__list--open .sub-nav-menu-types .nav-submenu__item:last-child a');
            const lastChildBudgetButton = document.querySelector('.nav-submenu__list--open .nav-selector__cta a');
            const lastChildrenMisc = document.querySelectorAll('.nav-submenu__list--open .sub-nav-menu-container .nav-submenu__item:last-of-type a');
            if (event.key == 'Tab' && event.shiftKey) {
                event.preventDefault();
                if (lastChildManufacturer != null) {
                    lastChildManufacturer.focus();
                } else if (lastChildType != null) {
                    lastChildType.focus();
                } else if (lastChildBudgetButton != null) {
                    lastChildBudgetButton.focus();
                } else if (lastChildrenMisc != null) {
                    lastChildrenMisc[lastChildrenMisc.length - 1].focus();
                }
            }
        }
    }

    function handleShiftTabOnBackButton(event) {
        if (event.key === 'Tab' && event.shiftKey) {
            event.preventDefault();
            closeButton.focus();
        }
    }

    function loopElementFocus(event) {
        if (event.key === 'Tab' && !event.shiftKey) {
            event.preventDefault();
            if (isMobile()) {
                closeButton.focus();
            } else {
                const navElement = document.querySelector('.nav-submenu__list--open');
                const firstSubItem = navElement.querySelector('.sub-nav-menu-container .nav-submenu__item:first-child a');

                firstSubItem.focus();
            }
        }
    }

    function backButtonFocus(event) {
        var navElement = document.querySelector('.nav-submenu__list--open');
        if (navElement != null) {
            var backButton = document.querySelector('.nav-submenu__list--open .nav-submenu__back-bar-link');
            if (event.key === 'Tab' && !event.shiftKey) {
                event.preventDefault();
                backButton.focus();
            }
        }
    }

    const init = () => {
        closeButton.addEventListener("keydown", backButtonFocus);
        closeButton.addEventListener("keydown", handleShiftTab);

        backButtons.forEach(function (back) {
            back.addEventListener("keydown", handleShiftTabOnBackButton);
        });

        vehicleMakeLastChild.addEventListener("keydown", loopElementFocus);
        vehicleTypeLastChild.addEventListener("keydown", loopElementFocus);
        viewCarResultsButton.addEventListener("keydown", loopElementFocus);
        viewBudgetResultsButton.addEventListener("keydown", loopElementFocus);
        contactUs.addEventListener("keydown", loopElementFocus);
        lastItemLinks.forEach((link) => link.addEventListener("keydown", loopElementFocus));
    };

    return {
        init: init
    };
};
